(function () {

    'use strict';

    // Init slider

    var imageSliders = document.querySelectorAll('.mol-intro-media .intro-media-slider');

    for (var i = 0; i < imageSliders.length; i++) {

        var swiperContainer = imageSliders[i].querySelector('.swiper');

        new Swiper(swiperContainer, {

            navigation: {
                
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
            },
        });
    }

    // Make thumbnail clickable
    
    $('.mol-intro-media .intro-media-video .atm-play').on('click', function (e) {

        e.stopPropagation();
    });

    $('.mol-intro-media .intro-media-video').on('click', function (e) {

        $(this).find('.atm-play').trigger('click');
    });

})();
